import { formatPercent, isNotNullOrUndefined } from '@converge/utils';

import { NotApplicable } from './not-applicable';
import { Typography } from '@mui/material';

export const PercentOrNotApplicable = ({
  children,
  tooltipText,
  times100 = true,
}: {
  children?: number | null | undefined;
  tooltipText?: string;
  times100?: boolean;
}) => {
  return isNotNullOrUndefined(children) ? (
    <Typography fontWeight={600} fontSize="14px">
      {formatPercent(
        Number((times100 ? children * 100 : children).toPrecision(2))
      )}
    </Typography>
  ) : (
    <NotApplicable tooltipText={tooltipText} />
  );
};
